var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { nanoid } from 'nanoid';
var Toast = /** @class */ (function () {
    function Toast() {
        /**
         * 生成唯一的id，当页面中存在多个toast时不至于冲突
         */
        this.id = nanoid();
        /**
         * 用于控制duration的定时器
         */
        this.timer = null;
        /**
         * toast的默认配置
         */
        this.config = {
            position: 'center',
            duration: 3000,
            type: 'text',
            forbidClick: false,
            dangerousHtml: false,
        };
        /**
         * 存储toast根元素的引用
         */
        this.rootEle = null;
        /**
         * 存储遮罩层根元素的引用
         */
        this.overlayEle = null;
        this.lockCount = 0;
        this.insertCss();
    }
    /**
     * 锁定阻止下层元素点击
     */
    Toast.prototype.lockClick = function () {
        if (!this.lockCount) {
            document.body.classList.add('funny-toast--unclickable');
            this.lockCount++;
        }
        else {
            this.lockCount--;
            document.body.classList.remove('funny-toast--unclickable');
        }
    };
    /**
     * 注入funny所需要的toast的css
     * @returns
     */
    Toast.prototype.insertCss = function () {
        var id = 'toast-style';
        if (document.querySelector('#' + id)) {
            return;
        }
        var styleNode = document.createElement('link');
        styleNode.id = id;
        styleNode.rel = 'stylesheet';
        styleNode.type = 'text/css';
        styleNode.href = '//res.cdn.changbaimg.com/-/7597c1e616638e03/funny-toast.css';
        document.head.appendChild(styleNode);
    };
    /**
     * 关闭toast
     * @returns
     */
    Toast.prototype.hide = function () {
        if (!this.rootEle) {
            return;
        }
        this.rootEle.style.display = 'none';
        if (this.overlayEle) {
            this.overlayEle.style.display = 'none';
        }
        this.toggleClickable();
    };
    /**
     * 销毁toast
     */
    Toast.prototype.destroy = function () {
        var _a, _b;
        if (this.rootEle) {
            (_a = this.rootEle.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(this.rootEle);
        }
        if (this.overlayEle) {
            (_b = this.overlayEle.parentElement) === null || _b === void 0 ? void 0 : _b.removeChild(this.overlayEle);
        }
    };
    /**
     * 切换解锁或锁定层
     */
    Toast.prototype.toggleClickable = function () {
        this.config.forbidClick && this.lockClick();
    };
    /**
     * 获取toast所需要展示的icon
     * @returns
     */
    Toast.prototype.genIcon = function () {
        var _a = this.config, icon = _a.icon, type = _a.type;
        var hasIcon = icon || type === 'success' || type === 'fail';
        if (hasIcon) {
            return "<i class=\"funny-icon iconfont funny-toast__icon icon-".concat(type, "\"></i>");
        }
    };
    /**
     * 对危险的html字符串进行转义
     * @param input
     * @returns
     */
    Toast.prototype.escapeHtmlTags = function (input) {
        return input.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    };
    /**
     * 生成toast要展示的文本内容
     * @returns
     */
    Toast.prototype.genMessage = function () {
        var _a = this.config, type = _a.type, message = _a.message;
        var msg = type === 'html' && this.config.dangerousHtml ? this.escapeHtmlTags(message) : message;
        return "<div class=\"funny-toast__".concat(type === 'html' ? 'html' : 'text', "\">").concat(msg, "</div>");
    };
    /**
     * 点击toast关闭toast
     * @returns
     */
    Toast.prototype.clickHandler = function () {
        if (!this.rootEle || !this.config.closeOnClick) {
            return;
        }
        this.rootEle.style.display = 'none';
        if (this.overlayEle) {
            this.overlayEle.style.display = 'none';
        }
    };
    /**
     * 创建一个遮罩层
     */
    Toast.prototype.createOverlay = function () {
        var overlay = document.createElement('div');
        overlay.classList.add('funny-overlay');
        document.body.appendChild(overlay);
        this.overlayEle = overlay;
    };
    /**
     * 打开toast
     * @param options
     */
    Toast.prototype.show = function (options) {
        var _this = this;
        if (typeof options === 'string') {
            this.config = __assign(__assign({}, this.config), { message: options });
        }
        else {
            this.config = __assign(__assign({}, this.config), options);
        }
        this.timer && clearTimeout(this.timer);
        if (this.rootEle) {
            this.rootEle.style.display = 'flex';
            if (this.overlayEle) {
                this.overlayEle.style.display = 'block';
            }
        }
        else {
            var toast = document.createElement('div');
            toast.id = this.id;
            toast.classList.add("funny-toast");
            toast.classList.add("funny-toast--".concat(this.config.position));
            toast.classList.add("funny-toast--".concat(this.config.type));
            var icon = this.genIcon() || '';
            var message = this.genMessage();
            toast.innerHTML = icon + message;
            toast.addEventListener('click', this.clickHandler.bind(this));
            if (this.config.mask) {
                this.createOverlay();
            }
            document.body.appendChild(toast);
            this.rootEle = toast;
        }
        this.toggleClickable();
        if (typeof this.config.duration === 'number' && this.config.duration > 0) {
            this.timer = setTimeout(function () {
                _this.hide();
            }, this.config.duration);
        }
    };
    return Toast;
}());
export { Toast };
